import React from "react";
import { Helmet } from "react-helmet-async";
import HeroBanner from "../../../Hero/HeroBanner";
import HeroPicBig from "../../../../../assets/medical/examinations/packages/nemi_korokozok/nemi_korokozok_banner_nagy.png";
import HeroPicSmall from "../../../../../assets/medical/examinations/packages/nemi_korokozok/nemi_korokozok_banner_kicsi.png";
import { examinationPackages } from "../../exams/examinationPackages";
import ExamCTA from "../../ExamCTA/ExamCTA";
import GoToPriceMultiple from "../GoToPrice/GoToPriceMultiple";
import ExamContent from "../ExamContent/ExamContent";
import "./examPackageSTD.css";

const ExamPackageSTD = () => {
  const stdTitle = examinationPackages[5].name;
  const stdSuggestedTo = examinationPackages[5].suggestedTo;
  const stdContains = examinationPackages[5].contains;

  // Create structured data for STD testing
  const stdTestingStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    "name": "Nemi betegségek kivizsgálása - Bálint Analitika",
    "description": "A Bálint Analitika laboratórium nemi betegségek (STD) kivizsgálási csomagjai diszkrét és megbízható szűrést biztosítanak.",
    "relevantSpecialty": ["InfectiousDisease", "Gynecology", "Urology"],
    "medicineSystem": "Conventional Medicine",
    "usedToDiagnose": "Sexually Transmitted Diseases",
    "normalRange": "Negative for pathogens",
    "affectedBy": ["Sexual activity", "Protection methods", "Number of partners"],
    "procedure": "Blood test, urine test, and swab samples depending on the package",
    "serviceProvider": {
      "@type": "MedicalBusiness",
      "name": "Bálint Analitika Laboratórium",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Kondorfa utca 6.",
        "addressLocality": "Budapest",
        "postalCode": "1116",
        "addressRegion": "XI. kerület",
        "addressCountry": "HU"
      }
    },
    "offers": {
      "@type": "Offer",
      "availability": "InStock",
      "priceCurrency": "HUF",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "price": "Varies by package"
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Nemi betegségek szűrése | STD tesztek | Bálint Analitika</title>
        <meta 
          name="description" 
          content="Diszkrét és megbízható nemi betegség szűrés (STD) a Bálint Analitika budapesti laboratóriumában. Átfogó vizsgálati csomagok, gyors és pontos eredmények."
        />
        <meta
          name="keywords"
          content="STD szűrés, nemi betegség teszt, szexuális úton terjedő betegségek, HPV teszt, HIV teszt, szifilisz teszt, Budapest"
        />
        <link 
          rel="canonical" 
          href="https://balintanalitika.hu/orvosdiagnosztika/vizsgalatok/csomagok/nemi-betegsegek"
        />
        <script type="application/ld+json">
          {JSON.stringify(stdTestingStructuredData)}
        </script>
      </Helmet>

      <HeroBanner 
        srcBig={HeroPicBig} 
        srcSmall={HeroPicSmall} 
        alt="Nemi betegségek szűrése és kivizsgálása a Bálint Analitika laboratóriumban"
      />

      <main className="std-package-page">
        <div className="container">
          <header className="std-package-header">
            <h1 className="heading-primary">Nemi betegségek szűrése és kivizsgálása</h1>
            <p className="std-package-intro">
              A Bálint Analitika laboratórium diszkrét és professzionális nemi betegség szűrést 
              kínál Budapest XI. kerületében. Korszerű diagnosztikai módszereinkkel gyorsan és 
              pontosan kimutathatók a szexuális úton terjedő fertőzések.
            </p>
          </header>

          <section className="std-package-content">
            <ExamContent
              title={stdTitle}
              suggestedTo={stdSuggestedTo}
              items={stdContains}
              isPackage={false}
              itemType="https://schema.org/MedicalTest"
            />
            
            <div className="std-package-additional-info">
              <h2 className="heading-secondary mt-0">Miért fontos a nemi betegségek szűrése?</h2>
              <p className="base-p-text">
                A nemi betegségek gyakran tünetmentesek, ezért rendszeres szűrésük kiemelten fontos 
                a szexuálisan aktív egyének számára. A korai diagnózis megelőzheti a súlyosabb 
                szövődményeket és csökkentheti a fertőzés továbbadásának kockázatát.
              </p>
              
              <h3 className="heading-tertiary">Mikor javasolt az STD szűrés?</h3>
              <ul className="exam-package-base-list">
                <li>Új szexuális partner esetén</li>
                <li>Ha Ön vagy partnere több szexuális kapcsolatot létesít</li>
                <li>Nem védett szexuális együttlét után</li>
                <li>Tünetek (viszketés, kiütés, fájdalom) megjelenése esetén</li>
                <li>Rendszeres egészségügyi ellenőrzés részeként</li>
              </ul>
              
              <h3 className="heading-tertiary">Diszkréció és adatvédelem</h3>
              <p className="std-package-intro">
                A Bálint Analitika laboratóriumban a legnagyobb diszkrécióval kezeljük a nemi 
                betegségek szűrését. Adatait bizalmasan kezeljük, az eredményekről csak Ön kap 
                tájékoztatást.
              </p>
            </div>

            <GoToPriceMultiple />
            
            <div className="std-package-contact" itemScope itemType="https://schema.org/MedicalOrganization">
              <h3 className="heading-tertiary">Konzultáció és időpontfoglalás</h3>
              <p className="base-p-text">
                A nemi betegségek szűrésével kapcsolatban bizalmas szakértői konzultációt biztosítunk.
              </p>
              <ExamCTA />
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default ExamPackageSTD;